var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "video-embed"
  }, [_c(_vm.embedComponent, {
    tag: "component",
    attrs: {
      "id": _vm.id
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }